import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter,ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {ApiService} from '../../api.service';
@Component({
    selector: 'app-home-work-request',
    templateUrl: './home-work-request.component.html',
    styleUrls: ['./home-work-request.component.css']
})
export class HomeWorkRequsetComponent implements OnInit, AfterViewInit {

    selectedTag: string = ""
    placeholder: string = ''
    constituteId: number;
    data : any = {}
    tabNum: number;
    isIcon : boolean = false
    isShowToast: boolean = false;
    destext : string = ""
    isShowPlaceholder: boolean = true; //是否显示placeholder
    textarea: any; //富文本对象
    type : any
    comment : any;//评论内容
    toastType : number;//评论 /追问 输入表情
	projectId : any;
	learningPathMetaId : any;
    constructor(
        private route: ActivatedRoute,
        private  apiService: ApiService,
        private el: ElementRef,
        private router: Router,) {
    }
    ngOnInit() {
        this.route.queryParams.subscribe(queryParams=>{
            this.data.relationId = queryParams['relationId'];
            this.constituteId = queryParams['constituteId'];
            this.tabNum = queryParams['tabNum'];
            this.type = queryParams['type'];
            this.comment = queryParams['comment'];
			this.learningPathMetaId = queryParams['learningPathMetaId'];
			this.projectId = queryParams['projectId'];
        })
    }

    ngAfterViewInit() {
        this.textarea = this.el.nativeElement.querySelector('textarea');
        if(this.comment){
            this.textarea.value = this.comment;
        }
    }
    back() {
        if(this.type === 'comment'){
            if(this.projectId){
                this.router.navigate(['home-work-show',this.constituteId],{queryParams:{'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,'projectId':this.projectId}});
            }else if(this.learningPathMetaId){
                this.router.navigate(['home-work-show',this.constituteId],{queryParams:{'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,'learningPathMetaId':this.learningPathMetaId}});
            }
        }else{
            if(this.projectId){
                this.router.navigate(['home-work-show',this.constituteId],{queryParams:{'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,'projectId':this.projectId}});
            }else if(this.learningPathMetaId){
                this.router.navigate(['home-work-show',this.constituteId],{queryParams:{'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,'learningPathMetaId':this.learningPathMetaId}});
            }
            // if(this.isFirstDay){
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId,firstDay:1}});
            // }else if(this.isLastDay){
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId,isLastDay:1}});
            // }else{
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId}});
            // }
        }
       
    }
    //发送
    send() {
        if(!localStorage.getItem("debuonceFlag")){
            localStorage.setItem("debuonceFlag","1");
            setTimeout(() => {
                localStorage.removeItem("debuonceFlag");
            }, 4000);
            if(this.type === 'comment'){
                //评论 输入不能为空 可以输入空格
                if(this.textarea.value.length > 0){
                    //掉接口.then
                    this.data.type = 'comment';
                    this.data.context = this.textarea.value;
                    this.isShowToast = false;
                    this.askQuestion(this.data).then(()=>{
                        this.textarea.value = "";
                        this.back();
                    }).catch(err=>{
                        if(err['error']['code'] === 101){
                            this.isShowToast = true;
                            this.toastType = 2;
                            this.destext = err['error']['msg'];
                            setTimeout(()=>{
                              this.isShowToast = false;
                            },1500);
                        }
                    })
                   
                }else{
                    this.isShowToast = true;
                    this.destext = '字数要大于0哦~';
                    if(this.isShowToast){
                        setTimeout(()=>{
                            this.isShowToast = false;
                        },2000)
                    }
                }
            }
        }
    }

    ngOnDestroy(){
        if(localStorage.getItem("debuonceFlag")){
            localStorage.removeItem("debuonceFlag");
        }
    }

    textareaFocus(){
        this.isShowPlaceholder = false;
    }
    
    //textarea失去焦点触发事件
    textareaBlur(){
        this.isShowPlaceholder = this.textarea.value === "" ? true : false;
    }

    //隐藏Placeholder
    closePlaceholder(){
        this.isShowPlaceholder = false;
        this.textarea.focus();
    }

    //追问 评论
    askQuestion(data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/user/project/homework/saveOperationLog',
            'data':data
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-request/home-work-request.component.ts